import { createStore } from 'vuex'

export default createStore({
  state: {
    theme: {
      brightness: 'light'
    }
  },
  mutations: {
    SET_THEME (state, theme) {
      state.theme = theme
    },
    TOGGLE_THEME_BRIGHTNESS (state) {
      state.theme.brightness =
        state.theme.brightness === 'dark' ? 'light' : 'dark'
    }
  },
  actions: {
  },
  modules: {
  }
})
